// extracted by mini-css-extract-plugin
export var header = "header-background-v2-module--header--f180a";
export var headerText = "header-background-v2-module--headerText--e2c59";
export var subtitle = "header-background-v2-module--subtitle--84248";